import React from 'react';
import ZipCodeMap from '../components/ZipCodeMap';

const ZipCodeMapPage = () => {
  return (
    <div className="container-fluid">
      <ZipCodeMap />
    </div>
  );
};

export default ZipCodeMapPage;